import UsersActionCreators from "@/Actions/User";
import { ZomentumRoutes, ZomentumWindow } from "@/Contracts";
import { safeRequestIdleCallback } from "@/Utils/safeRequestIdleCallback";
import { useNotForPdfView } from "@/Hooks";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { UIConfigActionCreators } from "@/Actions/UI";
import { GlobalState } from "@/Reducers/interface";
import useDispatch from "@/Components/Utils/useDispatch";
import { CustomFieldsActionCreators } from "@/Actions/CustomFields";
declare let window: ZomentumWindow;

interface ChargebeeScriptElement extends HTMLScriptElement {
	["data-cb-site"]?: string;
}

const LoadThirdPartyScripts: React.FC = () => {
	const dispatch = useDispatch();
	const { isLoggedIn, userCompany, currentActiveDocument } = useSelector(
		(state: GlobalState) => ({
			isLoggedIn: state.login.isLoggedIn,
			userCompany: state.user.userCompany,
			currentActiveDocument: state.documents.currentActiveDocument
		})
	);

	const isDocumentPreview = useRouteMatch(ZomentumRoutes.DocumentsPreview);

	useEffect(() => {
		if (isLoggedIn) {
			notForPdfView(getCustomFieldsData);
		}
	}, [isLoggedIn]);

	const { notForPdfView } = useNotForPdfView();

	const getCustomFieldsData = async () => {
		try {
			await dispatch(
				CustomFieldsActionCreators.getAllCustomFieldsForAllEntities()
			);
		} catch (error) {
			console.error(error);
		}
	};

	const initializeScripts = async () => {
		notForPdfView(() => {
			safeRequestIdleCallback(initializeChargebee);
		});
	};

	const initializeChargebee = () => {
		const existingScript = document.getElementById(
			"chargebee-initialization"
		);
		if (
			process.env.REACT_APP_CHARGEBEE_SITE &&
			process.env.REACT_APP_CHARGEBEE_PUBLISHABLE_KEY
		) {
			if (!existingScript) {
				const script: ChargebeeScriptElement =
					document.createElement("script");
				script.src = "https://js.chargebee.com/v2/chargebee.js";
				script["data-cb-site"] = process.env.REACT_APP_CHARGEBEE_SITE;
				script.id = "chargebee-initialization";
				document.body.appendChild(script);
				script.onload = () => {
					window.Chargebee.init({
						site: process.env.REACT_APP_CHARGEBEE_SITE,
						publishableKey:
							process.env.REACT_APP_CHARGEBEE_PUBLISHABLE_KEY
					});
				};
			}
		} else {
			throw new Error("Mandatory chargeebee env variables missing!");
		}
	};

	const getCollectJsToken = async (documentId: string) => {
		try {
			await dispatch(
				UIConfigActionCreators.getCollectJsToken(documentId)
			);
		} catch (err) {
			console.error(err);
		}
	};

	useEffect(() => {
		initializeScripts();
	}, []);

	useEffect(() => {
		if (
			isDocumentPreview?.isExact &&
			currentActiveDocument?.company?.integrations.connect_booster &&
			currentActiveDocument?.payment
		) {
			// The reason is manually parsing url  is that this component doesn't exist inside PrivateRoute
			const documentId = window.location.pathname.split("/").pop();
			if (documentId) getCollectJsToken(documentId);
		}
	}, [userCompany.integrations?.connect_booster, currentActiveDocument]);

	return null;
};

export default LoadThirdPartyScripts;
